<div
  class="relative flex aspect-3/4 scale-100 items-center justify-center overflow-hidden rounded-lg transition-transform"
>
  <div
    class="overflow-hidden -z-1 absolute top-0 right-0 w-full h-full group-[.selected]:scale-85 transition-transform duration-[150ms] rounded-lg bg-gray-200"
  >
    <div class="absolute top-0 right-0 -z-1">
      <div
        class="absolute top-0 right-0 size-16 -translate-y-1/2 translate-x-1/2 rounded-full border border-gray-300"
      ></div>

      <div
        class="absolute top-0 right-0 size-32 -translate-y-1/2 translate-x-1/2 rounded-full border border-gray-300"
      ></div>

      <div
        class="absolute top-0 right-0 size-48 -translate-y-1/2 translate-x-1/2 rounded-full border border-gray-300"
      ></div>

      <div
        class="absolute top-0 right-0 size-72 -translate-y-1/2 translate-x-1/2 rounded-full border border-gray-300"
      ></div>
    </div>
  </div>
  <div
    class="absolute inset-0 m-auto flex size-14 items-center justify-center rounded-full bg-gray-500 text-white"
  >
    <mat-icon>{{ data().icon ?? 'draft' }}</mat-icon>
  </div>

  @if (isImage()) {
    <img
      [src]="data().fileUrl"
      alt=""
      class="relative h-full w-full object-cover transition-opacity group-[.selected]:scale-85 transition-transform duration-[150ms] rounded-lg"
      [ngClass]="{
        'invisible opacity-0': !loaded(),
        'visible opacity-100': loaded(),
      }"
      loading="lazy"
      (load)="loaded.set(true)"
    />
  }

  @if (selectable()) {
    <div
      class="absolute top-0 left-0 size-10 p-2 opacity-0 transition-opacity group-not-[.persistent]:group-hover:opacity-100 group-[.persistent]:opacity-100 group-[.selected]:opacity-100"
    >
      <div
        class="group-[.selected]:bg-primary-700 group-[.selected]:border-primary-700 inline-flex size-6 items-center justify-center rounded-full border-2 border-white text-white transition-colors group-not-[.selected]:bg-white/[.16]"
      >
        <mat-icon
          class="shrink-0 transition-opacity group-not-[.selected]:opacity-0 group-[.selected]:opacity-100"
          >check_small</mat-icon
        >
      </div>
    </div>
  }

  @if (shareIndicator() === 'own') {
    <div
      class="absolute bottom-2 right-2 flex items-center justify-center rounded-full bg-primary-600 size-6 text-white shadow"
      title="Gedeeld door jou"
    >
      <!-- translate(1px, 1px) compensates for the 'share' icon's SVG being slightly off-center -->
      <mat-icon class="!text-sm !leading-none !size-4" style="translate: 1px 1px">share</mat-icon>
    </div>
  }

  @if (shareIndicator() === 'external') {
    <div
      class="absolute bottom-2 right-2 flex max-w-[70%] items-center gap-1 rounded-full bg-teal-600 px-2 py-0.5 text-white shadow"
      [title]="ownerUnitLabel()"
    >
      <mat-icon class="!text-sm flex-none !h-4 !w-4">group</mat-icon>
      @if (ownerUnitLabel()) {
        <span class="truncate text-xs font-medium leading-tight">{{ ownerUnitLabel() }}</span>
      }
    </div>
  }
</div>
<div class="mt-2 mb-4 line-clamp-2 min-h-10 px-4 text-center text-sm break-words">
  {{ data().label }}
</div>
